import React from 'react';
import styled from 'styled-components';
import { Form } from 'react-bootstrap';
import { SingleSelect } from '@atoms/Forms/Selects';

type SelectOption = {
    value: string,
    label: string,
}

type Props = {
    label: string,
    options: Array<SelectOption>,
    badge?: string,
    placeholder?: string,
}

const InputGroup = (props: Props) => {
    const { label, options, badge, placeholder } = props;

    return (
        <Form.Group>
            <Form.Label className="d-flex justify-content-between align-items-center">
                <LabelWithStyled>{ label }</LabelWithStyled>
                { badge && <BadgeWithStyled className="badge bg-secondary">{ badge }</BadgeWithStyled> }
            </Form.Label>
            <SingleSelect options={ options } placeholder={ placeholder } />
        </Form.Group>
    )
}

const LabelWithStyled = styled.span`
`
const BadgeWithStyled = styled.span`
`

export default InputGroup;